import React, { useState, useEffect, useCallback } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval } from 'date-fns';
import { hu } from 'date-fns/locale';
import AddIcon from '@material-ui/icons/Add';

import { Button, IconButton, Tooltip } from '@material-ui/core';
import NewCarDay from './NewCarDay';
import { NewObjectButton } from '../../../common/table/NewObjectButton';
import ActionMenu from '../../../common/action/ActionMenu';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import { CarDaySetting } from './CarDaySetting';
import WorkIcon from '@material-ui/icons/Work';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import { CookieSetter } from '../../../common/table/CookieSetter';
import RemoveIcon from '@material-ui/icons/Remove';
import { IconWithTooltip } from '../../../common/icons/IconWithTooltip';
import axios from 'axios';

const getCarKey = (car) => {
    return `CarIdAndLicenseNumber(carId=${car.carId}, licenseNumber=${car.licenseNumber})`;
};

function CarDayTableOther(props) {
    const { data, daysInMonth, refresh } = props;

    useEffect(function () {
        // console.log("data changed");
    }, [data]);

    return (
        <table className="carday-table" border="1">
            <thead>
                <tr>
                    {<th colSpan="2">Nap</th>}
                    {data.carIds?.map((car) => (
                        <th className='car car-border' colSpan="4" key={car.licenseNumber}>
                            {car.licenseNumber}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <>
                    <SumRow data={data} refresh={refresh} />
                    {daysInMonth.map((day) => (
                        <React.Fragment key={day.dateString}>
                            <CarDayHeader day={day} refresh={refresh} data={data} />
                            {Array.from({ length: (data.carDaysMap?.[day.dateString]?.maxLocations ?? 0) }, (_, index) => index)
                                .map(locIndex => (
                                    <CarDayLocation day={day} data={data} refresh={refresh} locIndex={locIndex} />
                                ))}
                        </React.Fragment>
                    ))}
                </>
            </tbody>
        </table>

    )
};

function SumRow(props) {

    const { data, refresh } = props;

    const getSumKm = useCallback((car) => {
        return "";
    }, [data]);

    return (
        <tr className='sum-row'>
            <td className='sum-amount' colSpan="2">Összesen</td>
            {data.carIds?.map((car) => (
                <td className='sum-amount' colSpan="4" key={car.licenseNumber}>
                    <Tooltip title="Tankolás"><LocalGasStationIcon color='primary' /></Tooltip>: {car.sumRefuelLiter ? car.sumRefuelLiter : 0} l, {car.sumRefuelForint ? car.sumRefuelForint : 0} Ft
                    <Tooltip title="Munka km"><WorkIcon color='primary' /></Tooltip>: {car.sumProjectKm ? car.sumProjectKm : 0} km
                    <Tooltip title="Egyéb km"><WorkOffIcon color='primary' /></Tooltip>: {car.sumOtherKm ? car.sumOtherKm : 0} km
                </td>
            ))}
        </tr>
    )
};

function CarDayHeader(props) {

    const { day, data, refresh } = props;

    const getRowSpan = useCallback((day) => {
        return data.carDaysMap && data.carDaysMap[day.dateString] && data.carDaysMap[day.dateString].maxLocations + 1;
    }, [data]);

    const getDriver = useCallback((day, car, d) => {
        if (d) {
            const key = getCarKey(car);
            return d.cars[key]?.driverName;
        }
        return "";
    }, [data]);

    const sumRefuelData = (refuels) => {
        let totalLiters = null;
        let totalForint = null;

        refuels.forEach(refuel => {
            if (refuel.refuelingAmountLiter !== null) {
                totalLiters = (totalLiters ?? 0) + refuel.refuelingAmountLiter;
            }
            if (refuel.refuelingAmountForint !== null) {
                totalForint = (totalForint ?? 0) + refuel.refuelingAmountForint;
            }
        });

        return {
            refuelingAmountLiter: totalLiters,
            refuelingAmountForint: totalForint
        };
    };
    const refuelAmount = (refuel) => {
        let result = "";
        if (refuel.refuelingAmountLiter) {
            result = `${refuel.refuelingAmountLiter}l`
        }
        return result;
    }

    const getRefuel = useCallback((car, d) => {
        if (d) {
            const key = getCarKey(car);
            if (d.cars[key]?.refuels) {
                const refuel = sumRefuelData(d.cars[key]?.refuels);
                const refuelA = refuelAmount(refuel);
                // console.log(refuel);
                return d.cars[key]?.refuels && <Tooltip title={`Tankolás ${refuelA}`}><LocalGasStationIcon color='primary' /></Tooltip>;
            }
            return "";
        }
        return "";
    }, [data]);

    const getCarDayData = useCallback((car, d) => {
        if (d) {
            const key = getCarKey(car);
            return d.cars[key];
        }
        return null;
    }, [data]);

    const setInactiveDay = (car, day) => {
        console.log(car);
        console.log(day);
        const path = '/api/carday';
        const requestObject = {
            "carId": car.carId,
            "licenseNumber": car.licenseNumber,
            "date": day.dateString,
            "active": false
        };
        callApi(path, requestObject).then(refresh);
    }

    const callApi = async (path, request) => {
        const response = await axios.post(path, request)
        console.log(response.data);
    };

    const isInactive = (data) => {
        if (data) {
            // console.log(data);
            if (data?.active === false) {
                console.log('nothing');
                return 'nothing';
            } else {
                return '';
            }
        } else {

            return '';
        }
    }

    const getColSpan = (data) => {
        if (data) {
            // console.log(data);
            if (data?.active === false) {
                console.log('nothing');
                return 4;
            } else {
                return 1;
            }
        } else {

            return 4;
        }
    }

    const isInactive2 = (data) => {
        if (data) {
            // console.log(data);
            if (data?.active === false) {
                console.log('nothing');
                return true;
            } else {
                return false;
            }
        } else {

            return true;
        }
    }

    return (
        <tr className={`${day.type} day-row`}>
            <td rowSpan={getRowSpan(day)} className='day'>{format(day.date, 'dd')}</td>
            <td rowSpan={getRowSpan(day)} className='day day-of-week'>{format(day.date, 'EEEE', { locale: hu })}</td>
            {data.carIds?.map((car) => (
                <React.Fragment key={car.licenseNumber}>
                    {/* <td className={`button car-border ${isInactive(getCarDayData(car, data.carDaysMap[day.dateString]))}`} colSpan={getColSpan(getCarDayData(car, data.carDaysMap[day.dateString]))}> */}
                    <td className={`button car-border ${isInactive(getCarDayData(car, data.carDaysMap[day.dateString]))}`} >
                        <NewObjectButton
                            newObjectLabel="Új"
                            refreshState={refresh}
                            dialogContent={(refresh, close) => (
                                <NewCarDay
                                    refresh={refresh}
                                    close={close}
                                    car={car}
                                    day={day.date}
                                    carDay={data.carDaysMap[day.dateString]?.cars[getCarKey(car)]}
                                />
                            )}
                            icon={<AddIcon color="primary" fontSize="small" />}
                        />
                    </td>
                    {/* {getCarDayData(car, data.carDaysMap[day.dateString])?.active &&
                        <> */}
                    <td className={`driver ${isInactive(getCarDayData(car, data.carDaysMap[day.dateString]))}`}>{getDriver(day, car, data.carDaysMap[day.dateString])} {getRefuel(car, data.carDaysMap[day.dateString])}</td>
                    <td className={`km-header ${isInactive(getCarDayData(car, data.carDaysMap[day.dateString]))}`}>{getCarDayData(car, data.carDaysMap[day.dateString])?.active && 'km'}</td>
                    <td className={`action-menu ${isInactive(getCarDayData(car, data.carDaysMap[day.dateString]))}`}>{
                        getCarDayData(car, data.carDaysMap[day.dateString])?.active ?
                            <ActionMenu row={getCarDayData(car, data.carDaysMap[day.dateString])} tabletype={'carday'} refresh={refresh} />
                            :
                            <Button onClick={() => setInactiveDay(car, day)}>
                                <IconWithTooltip title="semmi" >
                                    <RemoveIcon />
                                </IconWithTooltip>
                            </Button>
                    }
                    </td>
                    {/* </>} */}
                </React.Fragment>
            ))}
        </tr>
    )
};

function CarDayLocation(props) {

    const { day, data, refresh, locIndex } = props;

    const getLocData = useCallback((car, locIndex, d) => {
        const key = getCarKey(car);
        if (d[key]?.locations) {
            return d[key]?.locations[locIndex];
        } else {
            return null;
        }
    }, [data]);

    const getLoc = useCallback((car, locIndex, d) => {
        const key = getCarKey(car);
        if (d[key]?.locations) {
            const result = d[key]?.locations[locIndex]?.locationName || d[key]?.locations[locIndex]?.projectLocation;
            return result;
        } else {
            return '';
        }
    }, [data]);

    const getKm = useCallback((car, locIndex, d) => {
        const key = getCarKey(car);
        if (d[key]?.locations) {
            const result = d[key]?.locations[locIndex]?.km;
            return result;
        } else {
            return '';
        }
    }, [data]);

    return (
        <tr key={`${day.dateString}-location-${locIndex}`}>
            {data.carIds?.map((car) => (
                <React.Fragment key={`${car.licenseNumber}-${locIndex}`}>
                    <td className='car-border'></td>
                    <td className='data'>{getLoc(car, locIndex, data.carDaysMap[day.dateString].cars)}</td>
                    <td className='km'>{getKm(car, locIndex, data.carDaysMap[day.dateString].cars)}</td>
                    <td className='action-menu'>{getLocData(car, locIndex, data.carDaysMap[day.dateString].cars) && <ActionMenu row={getLocData(car, locIndex, data.carDaysMap[day.dateString].cars)} tabletype={'cardaylocation'} refresh={refresh} />}</td>
                </React.Fragment>
            ))}
        </tr>
    )
};
export default CarDayTableOther;